import React from 'react'
import {
  Row,
  Col,
  Card,
  Table,
  Tag,
  Button,
  Badge,
  Popconfirm,
  Empty,
  Modal,
  Input,
  message,
} from 'antd'
import { Moment, openNotificationWithIcon } from '../../../helpers'
import './style.scss'
import { Config } from '../../../config'
import { inject, observer } from 'mobx-react'
import 'react-fancybox/lib/fancybox.css'
import Gallery from '../../gallery/gallery-list'
import { JobStatus } from '../JobStatus'
import { JobDateTime } from '../JobDateTime'
import { JobTechnichian } from '../JobTechnichian'
import TableResponsiveOK from '../../_shared/responsive-table'
import {
  DashOutlined,
  CloseSquareFilled,
  HomeFilled,
  UserOutlined,
  HomeOutlined,
} from '@ant-design/icons'
import { JobService, InformfixService } from '../../../services'

const IconText = ({ type, text }) => <span>{text}</span>

@inject('informStore')
@observer

/**
 * แสดงรายละเอียดเพื่อแจ้งเลื่อน งานๆ
 */
class JobPostpone extends React.Component {
  state = {}

  /**
   * นับสถานะใบแจ้งซ่อม
   */
  getCountAllStatus() {
    console.log('check count inform')
    InformfixService.countNewInform().then((rs) => {
      if (rs) {
        console.log('countNewInform', rs.data)
        const data = rs.data
        this.props.informStore.countNewInform = data.total
      }
    })
    InformfixService.count4task().then((rs) => {
      console.log('count4task', rs)
      if (rs) {
        const data = rs.data
        this.props.informStore.count4task = data.total
      }
    })
    InformfixService.countPostpone().then((rs) => {
      if (rs) {
        console.log('countPostpone', rs.data)
        const data = rs.data
        this.props.informStore.countPostpone = data.total
      }
    })
  }

  postponeJob = (row) => {
    let remark = document.getElementById('postpone_remark' + row.id).value
    //let remark = this.refs.postpone_remark + row.id.value
    let params = { remark: remark }

    JobService.postponeJob(row.id, params).then((rs) => {
      if (rs) {
        const data = rs.data
        const job = data.data
        let informfix = this.props.informStore.getItem
        let informList = this.props.informStore.getItems
        let jobs = this.props.informStore.getJobItems
        informList.map((inform, informKey) => {
          if (inform.id == informfix.id) {
            informList[informKey] = job.informFix
            this.props.informStore.setItems(informList)
          }
        })

        this.props.informStore.setItem(informfix)
        jobs.map((j, jk) => {
          if (j.id == job.id) {
            jobs[jk] = job
            let informfix = job.informFix
            this.props.informStore.setJobItems(jobs)
          }
        })
        // this.props.onCloseJob({
        //   job: job,
        //   inform: informfix,
        // })
        // openNotificationWithIcon('success', data.message)
        message.success(data.message)
        this.getCountAllStatus()
      }
    })
  }

  render() {
    const jobs = this.props.informStore.getJobItems
    const inform = this.props.informStore.getItem
    // แสดงวันที่
    const showFormatDate = (datetime) => {
      let date = Moment(datetime)
      if (date.isValid()) {
        return date.format('ll')
      } else {
        return
      }
    }
    // แสดงเวลา
    const showFormatTime = (datetime) => {
      const time = Moment(datetime)
      if (time.isValid()) {
        return (
          <Tag size="small" color="#383838">
            {time.format('LT')} น.
          </Tag>
        )
      } else {
        return
      }
    }

    // ชื่อช่าง
    const technicianName = (job) => {
      if (job.technicians && job.technicians.length > 0) {
        let name = ''
        let names = []
        job.technicians.map((v, tkey) => {
          if (v.technician) {
            if (v.technician) {
              names.push(
                <span key={tkey} style={{ marginRight: 3 }}>
                  {v.technician.firstname}
                </span>,
              )
            }
          }
        })
        return names
      }
    }

    // แสดงวันที่ from unix timestamp
    const showTimeFromUnix = (datetime) => {
      let date = Moment.unix(datetime)
      if (date.isValid()) {
        return date.format('lll น.')
      } else {
        return
      }
    }
    // แสดงวันที่
    const showTime = (datetime) => {
      let date = Moment(datetime)
      if (date.isValid()) {
        return date.format('lll น.')
      } else {
        return
      }
    }

    const showDetail = (record) => {
      return (
        <Row
          style={{
            fontSize: '12px',
          }}
          gutter={[8, 8]}
        >
          {record.informFix ? (
            <Col>
              <HomeOutlined /> {'  '}
              {record.informFix.project.name}
            </Col>
          ) : null}

          {record.informFix ? (
            <Col>
              <HomeOutlined />
              {'  '}
              {'เลขที่ ' + record.informFix.home.home_no}
              {record.home && record.home.homeType
                ? '(' + record.home.homeType.name + ')'
                : null}
              {' แปลง ' + record.informFix.home.plan_no}
            </Col>
          ) : null}
          {record.technicians && record.technicians.length > 0 ? (
            <Col>
              <UserOutlined /> {'  '}
              {record.technicians ? technicianName(record) : null}
            </Col>
          ) : null}
        </Row>
      )
    }

    return (
      <React.Fragment>
        <Modal
          key="modal-job-postpone"
          title="รายละเอียดงาน"
          open={this.props.visible}
          cancelText="ปิดหน้าต่าง"
          maskClosable
          onCancel={() => this.props.onHide(false)}
          footer=""
          bodyStyle={{
            padding: '7px',
            backgroundColor: '#ffffff',
            color: '#222222',
          }}
          style={{ top: 5 }}
          destroyOnClose
        >
          {inform ? (
            <div
              style={{
                margin: '0 auto',
              }}
            >
              <Row align="top" gutter={[4, 4]}>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 24 }}
                >
                  {jobs && jobs.length > 0 ? (
                    <React.Fragment>
                      {jobs.map((job, key) => (
                        <Card
                          key={key}
                          bodyStyle={{
                            padding: 7,
                            backgroundColor: '#ffffff',
                            color: '#222222',
                            boxShadow: '2px 2px 2px 2px',
                          }}
                          style={{
                            marginBottom: 7,
                          }}
                        >
                          <h3>{job.list}</h3>
                          <div>
                            <span style={{ fontSize: '.7rem' }}>
                              {job.start_time &&
                              Moment(job.start_time).isValid() ? (
                                <Badge>
                                  {Moment(job.start_time)
                                    .utc(7)
                                    .format('ll HH:mm')}
                                </Badge>
                              ) : null}
                              {job.end_time &&
                              Moment(job.end_time).isValid() ? (
                                <React.Fragment>
                                  {' - '}
                                  <Badge>
                                    {Moment(job.end_time)
                                      .utc(7)
                                      .format('ll HH:mm')}
                                  </Badge>
                                </React.Fragment>
                              ) : null}
                            </span>
                          </div>
                          <div>
                            ID#{job.id}{' '}
                            <JobStatus
                              name={job.jobStatusName}
                              statusId={job.job_status}
                            />
                            <JobTechnichian technicians={job.technicians} />
                          </div>
                          <p>{job.description}</p>
                          {showDetail(job)}
                          {job.job_status !=
                          Config.job.status.COMPLETE.value ? (
                            <p>
                              <Input.TextArea
                                placeholder="หมายเหตุแจ้งเลื่อน...."
                                ref={'postpone_remark' + job.id}
                                id={'postpone_remark' + job.id}
                                defaultValue={job.postpone_remark}
                                disabled={job.postpone_mark ? true : false}
                              />
                              <Popconfirm
                                disabled={job.postpone_mark ? true : false}
                                title="ต้องการแจ้งให้หัวหน้าช่างเลื่อนคิว ใช่หรือไม่ ?"
                                onConfirm={() => this.postponeJob(job)}
                                okText="ใช่"
                                cancelText="ไม่"
                              >
                                <Button
                                  disabled={job.postpone_mark ? true : false}
                                  size="small"
                                  type="primary"
                                  icon={<CloseSquareFilled />}
                                >
                                  แจ้งให้เลื่อนคิว
                                </Button>
                              </Popconfirm>
                            </p>
                          ) : null}
                        </Card>
                      ))}
                    </React.Fragment>
                  ) : (
                    <Empty />
                  )}
                </Col>
              </Row>
            </div>
          ) : null}
        </Modal>
      </React.Fragment>
    )
  }
}

export default JobPostpone
